import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InventoryService } from '../../../services/inventory.service';
import { SharedModule } from '../../../shared/shared.module';

@Component({
  selector: 'app-specification-lookup',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './specification-lookup.component.html',
  styleUrl: './specification-lookup.component.scss'
})
export class SpecificationLookupComponent {

  constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig, private inventoryService: InventoryService,
    private messageService: MessageService
  ) { }

  selectedSpecification: string | undefined;
  product: any;
  loader: boolean = false;
  productSpecification: string | undefined;
  freeHandProductSpecification: string | undefined;
  Edit: boolean = false;

  ngOnInit(): void {
    const lineItemData = this.config.data;
    this.Edit = this.config.data.Edit;
    this.product = lineItemData;
    const productId = lineItemData.ProductId || lineItemData.productId;
    if (!productId) {
      this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Incomplete Product Data.' });
      return;
    }
    this.inventoryService.getProductById(productId).subscribe({
      next: (data: any) => {
        if(data.productSpecification || lineItemData.ProductSpecification){
        this.productSpecification = data.productSpecification;
        if (lineItemData.ProductSpecification.trim() == data.productSpecification) {
          this.selectedSpecification = 'default';
        } else {
          this.selectedSpecification = 'other';
          this.freeHandProductSpecification = lineItemData.ProductSpecification;
        }
      }else{
        this.selectedSpecification = 'other';
      }
      },
      error: (error) => {
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Error while fetching product data.' });
        console.log(error);
        this.loader = false;
      }
    });

  }


  saveSpecification() {

    if (this.selectedSpecification == 'other') {
      if (!this.freeHandProductSpecification || this.freeHandProductSpecification.trim() === "") {
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Please Enter Free-hand Specification' });
        return;
      }

      this.product.ProductSpecification = this.freeHandProductSpecification;
    } else {
      this.product.ProductSpecification = this.productSpecification;
    }

    this.ref.close(this.product);
  }
}
